import { render, staticRenderFns } from "./Betslip.vue?vue&type=template&id=d9fdff80"
import script from "./Betslip.vue?vue&type=script&lang=js"
export * from "./Betslip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports